module.exports = __webpack_public_path__ + "images/home_1024.jpg";